export default "__VITE_ASSET__AdYxh9aV__"